<div class="swiper-container">
<!--todo  [(index)]="activeIndex" [swiper]="config">-->
  <div class="swiper-wrapper">
    <div *ngFor="let file of files" class="swiper-slide flex flex-col items-center">
      <div class="icon-container" (click)="showPreview.emit()">
        <app-icon name="image" size="48" color="#ff6200"></app-icon>
        <span class="file-name">{{ file.fileData?.name }}</span>
      </div>
    </div>
  </div>
  <div class="swiper-pagination"></div>
</div>
